import composition from "rfuncs/functions/composition"
import { endswith, startswith } from "workflow/utils/strings"

export default composition(
  path => (endswith(path, "/") ? path : `${path}/`),
  path => (startswith(path, "/") ? path : `/${path}`)
)
